import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { supportedLngs } from './locales';

// Region variants that ship their own translation file; every other
// detected region (e.g. en-US, de-AT) is normalized to its base language
// before being requested, so nonExplicitSupportedLngs never triggers a
// 404 for a file that doesn't exist.
const REGIONAL_LOCALES_WITH_OWN_FILE = [
  'en-GB',
  'es-419',
  'es-MX',
  'fr-CA',
  'pt-BR',
  'nb-NO',
];

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: ([lng], [ns]) => {
        const resolvedLng = REGIONAL_LOCALES_WITH_OWN_FILE.includes(lng)
          ? lng
          : lng.split('-')[0];
        return ns === 'common'
          ? `/locales/${resolvedLng}.json`
          : `/locales/${ns}/${resolvedLng}.json`;
      },
    },
    ns: ['common', 'blueprint'],
    defaultNS: 'common',
    supportedLngs,
    nsSeparator: false,
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['navigator'],
    },
    react: {
      useSuspense: true,
    },
  });
